import VNavigationDrawer from './VNavigationDrawer';

VNavigationDrawer.install = function install(Vue) {
  Vue.component(VNavigationDrawer.name, VNavigationDrawer);
};

export default VNavigationDrawer;


//////////////////
// WEBPACK FOOTER
// ./~/vuetify/es5/components/VNavigationDrawer/index.js
// module id = rPQa
// module chunks = 0